import GoogleRecaptcha from './GoogleRecaptcha';

export default GoogleRecaptcha;
